import * as React from 'react';
import { Producer, Branch, SummaryProducer } from '../Models/Report';
import './Popper.scss';
import { formatAmount } from '../Utils/NumberFormat';
import Skeleton from 'antd/lib/skeleton';
import Balloon from './Balloon';
import Tooltip from 'antd/lib/tooltip';

export interface IPopperProps {
	producer: Producer;
}

const getTotalBranch = (branch: Branch, summary: SummaryProducer) => {
	const s = summary.branchs.find(sb => sb.id === branch.id);
	return s ? s.total : 0;
}

const Popper = (props: IPopperProps) => {
	const color = props.producer.color;
	return (<div className="Popper">
		<Tooltip overlay={props.producer.name} className="Popper-name">
			<Balloon color={color} size={16} />
			<span>{props.producer.name}</span>
		</Tooltip>
		<div className="Popper-total">
			<Skeleton active paragraph={{ rows: 0 }} loading={props.producer.loading}>
				<span style={{ borderBottom: `1px solid ${color}` }}>
					{formatAmount(props.producer.summary.total)}
					<span>kton</span>
				</span>
			</Skeleton>
		</div>
		<div className="Popper-branchs">
			{props.producer.branchs.map(b => <div key={b.name}>{b.name}</div>)}
		</div>
		<div className="Popper-branchs-total">
			{props.producer.branchs.map(b => (<Skeleton active paragraph={{ rows: 0 }} loading={props.producer.loading}>
				<div>
					<span style={{ borderBottom: `1px solid ${color}` }}>
						{formatAmount(getTotalBranch(b, props.producer.summary))}
						<span>kton</span>
					</span>
				</div>
			</Skeleton>)
			)}
		</div>
	</div>)
};

export default Popper;
